import React from 'react';
import { Box, Container, Typography, IconButton, Divider, Link, Tooltip } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import ChatIcon from '@mui/icons-material/Chat';

function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                mt: 'auto',
                py: 3,
                borderTop: '1px solid rgb(55, 65, 81)',
                backgroundColor: 'rgba(17, 24, 39, 0.98)',
                minHeight: '80px',
                flexShrink: 0,
            }}
        >
            <Container maxWidth="auto">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            mb: { xs: 2, sm: 0 },
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'rgb(196, 181, 253)',
                                fontWeight: 500,
                            }}
                        >
                            © {new Date().getFullYear()} playLorcana.pl
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                        }}
                    >
                        <Tooltip title="Dołącz do naszego Discorda">
                            <IconButton
                                href="https://discord.gg/Sx3NyyJpqT"
                                target="_blank"
                                sx={{
                                    color: 'rgb(196, 181, 253)',
                                    transition: 'all 0.3s ease',
                                    padding: '8px',
                                    '&:hover': {
                                        color: '#5865F2',
                                        transform: 'translateY(-2px)'
                                    },
                                }}
                            >
                                <ChatIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>

                        <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(76, 29, 149, 0.3)' }} />

                        <Tooltip title="Obserwuj nas na Instagramie">
                            <IconButton
                                href="https://www.instagram.com/playlorcana_pl/"
                                target="_blank"
                                aria-label="Instagram"
                                sx={{
                                    color: 'rgb(196, 181, 253)',
                                    transition: 'all 0.3s ease',
                                    padding: '8px',
                                    '&:hover': {
                                        color: '#E1306C',
                                        transform: 'translateY(-2px)'
                                    },
                                }}
                            >
                                <InstagramIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>

                        <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(76, 29, 149, 0.3)' }} />

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: 'rgb(196, 181, 253)',
                            }}
                        >
                            <EmailIcon fontSize="small" sx={{ mr: 0.5 }} />
                            <Link
                                href="mailto:contact@playlorcana.pl"
                                sx={{
                                    color: 'rgb(196, 181, 253)',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        textDecoration: 'underline',
                                        color: 'white',
                                    },
                                    transition: 'color 0.2s',
                                    fontSize: '0.875rem',
                                }}
                            >
                                contact@playlorcana.pl
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;